import { useState } from 'react';
import { AuditTrail } from '@/components/admin/AuditTrail';
import { useAuditTrail } from '@/hooks/useAdmin';

interface ActivityLogSectionProps {
  readonly orderId: string;
}

export const ActivityLogSection = ({ orderId }: ActivityLogSectionProps) => {
  const [open, setOpen] = useState(false);
  const { data: trail } = useAuditTrail(orderId);
  const eventCount = trail?.length ?? 0;

  return (
    <div
      style={{
        border: '0.5px solid var(--border-default)',
        borderRadius: 'var(--radius-md)',
        marginBottom: '8px',
        overflow: 'hidden',
      }}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 14px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--text-primary)',
          transition: 'background-color 100ms',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--bg-surface-sunken)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
      >
        <span>Activity log</span>
        <span
          style={{
            fontSize: '11px',
            color: 'var(--text-tertiary)',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          {eventCount} event{eventCount !== 1 ? 's' : ''}
          <span
            style={{
              transition: 'transform 200ms',
              transform: open ? 'rotate(90deg)' : 'rotate(0)',
              fontSize: '10px',
            }}
          >
            &#9654;
          </span>
        </span>
      </div>

      {open && (
        <div style={{ padding: '0 14px 10px' }}>
          <AuditTrail entityId={orderId} />
        </div>
      )}
    </div>
  );
};
